<div hlmSidebarWrapper>
  @if (authService.user | async; as user) {
    <hlm-sidebar>
      <!-- Header: Logo -->
      <div hlmSidebarHeader>
        <ul hlmSidebarMenu>
          <li hlmSidebarMenuItem>
            <a hlmSidebarMenuButton routerLink="/" class="!h-10">
              <img src="../assets/img/HEALTH+LIFE-MED.png" alt="Logo" class="h-6 w-auto" />
            </a>
          </li>
        </ul>
      </div>

      <!-- Main navigation -->
      <div hlmSidebarContent>
        @if (user.companyId) {
          <!-- General section -->
          <div hlmSidebarGroup>
            <div hlmSidebarGroupLabel>Allgemein</div>
            <div hlmSidebarGroupContent>
              <ul hlmSidebarMenu>
                @if (!companyService.isBookingProfileRestricted) {
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/" routerLinkActive="bg-sidebar-accent" [routerLinkActiveOptions]="{exact: true}">
                      <lucide-icon [img]="GaugeIcon" [size]="16" />
                      <span>Der heutige Tag</span>
                    </a>
                  </li>
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/blutabnahmen" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="DropletIcon" [size]="16" />
                      <span>Heutige Blutabnahmen</span>
                    </a>
                  </li>
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/untersuchungstermine" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="StethoscopeIcon" [size]="16" />
                      <span>Heutige Untersuchungen</span>
                    </a>
                  </li>
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/workflows" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="GitBranchIcon" [size]="16" />
                      <span>Workflows</span>
                    </a>
                  </li>
                }
                <li hlmSidebarMenuItem>
                  <a hlmSidebarMenuButton routerLink="/kalender" routerLinkActive="bg-sidebar-accent">
                    <lucide-icon [img]="CalendarIcon" [size]="16" />
                    <span>Kalender</span>
                  </a>
                </li>
                @if (companyService.hasPermission('editor') && !companyService.isBookingProfileRestricted) {
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/kunden" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="UsersIcon" [size]="16" />
                      <span>Alle Kunden</span>
                    </a>
                  </li>
                }
                @if (!companyService.isBookingProfileRestricted) {
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/offene-kunden" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="RouteIcon" [size]="16" />
                      <span>Offene Kunden</span>
                    </a>
                  </li>
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/erinnerungen" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="BellIcon" [size]="16" />
                      <span>Erinnerungen</span>
                    </a>
                  </li>
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/termine" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="CalendarCheckIcon" [size]="16" />
                      <span>Alle Termine</span>
                    </a>
                  </li>
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/feedback" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="StarIcon" [size]="16" />
                      <span>Feedback</span>
                    </a>
                  </li>
                  @if (companyService.hasPermission('editor')) {
                    <li hlmSidebarMenuItem>
                      <a hlmSidebarMenuButton routerLink="/verfuegbarkeit" routerLinkActive="bg-sidebar-accent">
                        <lucide-icon [img]="ClockIcon" [size]="16" />
                        <span>Verfügbarkeit</span>
                      </a>
                    </li>
                  }
                }
                @if (!companyService.isBookingProfileRestricted) {
                  <li hlmSidebarMenuItem>
                    <a hlmSidebarMenuButton routerLink="/nutzerprofile" routerLinkActive="bg-sidebar-accent">
                      <lucide-icon [img]="ContactIcon" [size]="16" />
                      <span>Nutzerprofile</span>
                    </a>
                  </li>
                }
              </ul>
            </div>
          </div>

          @if (!companyService.isBookingProfileRestricted) {
            <div hlmSidebarSeparator></div>

            <!-- Settings section -->
            <div hlmSidebarGroup>
              <div hlmSidebarGroupLabel>Einstellungen</div>
              <div hlmSidebarGroupContent>
                <ul hlmSidebarMenu>
                  @if (companyService.hasPermission('editor')) {
                    <li hlmSidebarMenuItem>
                      <a hlmSidebarMenuButton routerLink="/buchungsprofil" routerLinkActive="bg-sidebar-accent">
                        <lucide-icon [img]="BriefcaseIcon" [size]="16" />
                        <span>Buchungsprofile</span>
                      </a>
                    </li>
                    <li hlmSidebarMenuItem>
                      <a hlmSidebarMenuButton routerLink="/leistungen" routerLinkActive="bg-sidebar-accent">
                        <lucide-icon [img]="BriefcaseIcon" [size]="16" />
                        <span>Leistungen</span>
                      </a>
                    </li>
                    <li hlmSidebarMenuItem>
                      <a hlmSidebarMenuButton routerLink="/module" routerLinkActive="bg-sidebar-accent">
                        <lucide-icon [img]="LayersIcon" [size]="16" />
                        <span>Module</span>
                      </a>
                    </li>
                    <li hlmSidebarMenuItem>
                      <a hlmSidebarMenuButton routerLink="/statistik" routerLinkActive="bg-sidebar-accent">
                        <lucide-icon [img]="BarChart2Icon" [size]="16" />
                        <span>Statistik</span>
                      </a>
                    </li>
                  }
                  @if (companyService.hasPermission('admin')) {
                    <li hlmSidebarMenuItem>
                      <a hlmSidebarMenuButton routerLink="/email-vorlagen" routerLinkActive="bg-sidebar-accent">
                        <lucide-icon [img]="MailIcon" [size]="16" />
                        <span>Email-Vorlagen</span>
                      </a>
                    </li>
                    <li hlmSidebarMenuItem>
                      <a hlmSidebarMenuButton routerLink="/firmen-einstellungen" routerLinkActive="bg-sidebar-accent">
                        <lucide-icon [img]="Building2Icon" [size]="16" />
                        <span>Organisation</span>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
        }
      </div>

      <!-- Footer: User profile with dropdown -->
      <div hlmSidebarFooter class="border-t border-border">
        <ul hlmSidebarMenu>
          <li hlmSidebarMenuItem>
            <hlm-dropdown-menu class="!border-0 !shadow-none !bg-transparent !p-0 !m-0 !rounded-none !min-w-0 !z-auto">
              <button hlmSidebarMenuButton brnDropdownMenuTrigger size="lg">
                <app-display-profile-img
                  [title]="user.displayName || user.email"
                  [img]="user.profileImg"
                  [imgThumb]="user.profileImgThumb"
                  [size]="'32px'"
                />
                <div class="grid flex-1 text-left text-sm leading-tight">
                  <span class="truncate font-semibold">{{ user.displayName || user.email }}</span>
                </div>
              </button>
              <ng-template brnDropdownMenuContent>
                <div hlmDropdownMenuContent class="w-56">
                  <a hlmDropdownMenuItem routerLink="/benutzer-einstellungen">
                    <lucide-icon [img]="SettingsIcon" [size]="16" class="mr-2" />
                    Benutzereinstellungen
                  </a>
                  <div hlmDropdownMenuSeparator></div>
                  <button hlmDropdownMenuItem (click)="onLogout()">
                    <lucide-icon [img]="LogOutIcon" [size]="16" class="mr-2" />
                    Abmelden
                  </button>
                </div>
              </ng-template>
            </hlm-dropdown-menu>
          </li>
        </ul>
      </div>
    </hlm-sidebar>
  }

  <!-- Main content area — always rendered so router-outlet is always present -->
  <main hlmSidebarInset>
    @if (authService.user | async) {
      <!-- Top bar with trigger + calendar header -->
      <header class="flex h-14 items-center gap-2 border-b border-border px-4 no-print">
        <button hlmSidebarTrigger>
          <span class="sr-only">Toggle Sidebar</span>
        </button>
        <ng-content select="[calendarHeader]" />
      </header>
    }
    <ng-content />
  </main>
</div>
